import axios from 'axios'
import { Modal, message } from 'antd'
import { getToken, setToken, removeToken } from './token-util'
import history from '@/utils/history'
import { WHITE_LIST, TOKEN_HEADER_NAME } from '@/config/setting'
import qs from 'qs'
import axiosRetry from 'axios-retry'

let appConfig = window?.appConfig ?? ''

let { REACT_APP_MODE, NODE_ENV } = process.env

const BASE_URL = window.location.host

const REQUEST_CONFIG = appConfig ? appConfig[REACT_APP_MODE][NODE_ENV] : undefined

axiosRetry(axios, { retries: 3, retryDelay: (retryCount) => retryCount * 1000 })
const keyMap = new Map() // 保存唯一的key
const service = axios.create({
  baseURL: REQUEST_CONFIG ? REQUEST_CONFIG['REACT_APP_API_BASE_URL'] : '',
  // 请求多久延时 
  timeout: 120000,
  isTips: true,
  // 设置请求头
  headers: {
    'Content-Type': 'application/json'
  }
})




/**
 * @description: 获取唯一标识
 * @param {*} config
 * @return {*}
 */
const generateRequestKey = (config) => {
  let { url, method, params, data } = config;
  // if (method === 'post') {
  //   url = url.split('?')?.[0]
  //   return [url, method].join('&')
  // } else {
    return [url, method, qs.stringify(params), qs.stringify(data)].join('&')
  // }
}

/**
 * @description: 添加请求
 * @param {*} config
 * @return {*}
 */
const addPendingRequest = (config) => {
  const key = generateRequestKey(config);
  if(!keyMap.has(key)){
    config.cancelToken = new axios.CancelToken(cancel => {
      keyMap.set(key, cancel);
    })
  }
}

/**
 * @description: 删除重复请求
 * @param {*} config
 * @return {*}
 */
const removePendingRequest = (config) => {
  const key = generateRequestKey(config);
  if(keyMap.has(key)){
    const cancelToken = keyMap.get(key);
    cancelToken('已取消请求');
    keyMap.delete(key);
  }
}


/**
 * 添加请求拦截器
 */
service.interceptors.request.use((config) => {
    removePendingRequest(config);
    addPendingRequest(config);
    // 添加 token 到 header
    const token = getToken()
    if (config.hasOwnProperty('requestBaseUrl')) {
      config.baseURL = REQUEST_CONFIG['REACT_APP_API_REPORT']
      
    } else {
      // config.baseURL = REQUEST_CONFIG['REACT_APP_API_BASE_URL']
      config.baseURL = REQUEST_CONFIG.NODE_ENV === 'development' ? '/api' : REQUEST_CONFIG['REACT_APP_API_BASE_URL']
    }
    if (config.headers['Content-Type'] && typeof(config.headers['Content-Type']) === 'string' && config.headers['Content-Type'].indexOf('application/json') > -1) {
      config.data = JSON.stringify(config.data)
    } else {
      if (config.method === 'post' && config.headers['Content-Type'].indexOf('multipart/form-data') === -1) {
        let data = qs.parse(config.data)
        config.data = qs.stringify({ ...data })
      } else if (config.method === 'get') {
        config.params = { ...config.params }
      }
    }

    if (token && config.headers) {
      config.headers[TOKEN_HEADER_NAME] = token
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

/**
 * 添加响应拦截器
 */
service.interceptors.response.use(
  (res) => {
    removePendingRequest(res.config)
    const currentPath = history.location.pathname
    let isLogin = WHITE_LIST.indexOf(currentPath) !== -1
    // // // 登录过期处理
    if (res.config.responseType === 'blob') {
      return res
    } else if (res.data?.code === 401) {
      
      showMessageBox({
        title: '系统提示',
        content: res.data?.message || '您的登录已过期，请重新登录！',
        isLink: !isLogin,
        link: BASE_URL + '/login' + (currentPath ? '?from=' + currentPath : ''),
      })
    } else if (res.data?.code === 402) { // 登录过期处理
      showMessageBox({
        title: '系统提示',
        content: '您的帐号已在其他设备登录，请确认帐号安全!',
        isLink: !isLogin,
        link: BASE_URL + '/login' + (currentPath ? '?from=' + currentPath : ''),
      })
    } else if (res.data?.code === 403) { // 账号过期
      showMessageBox({
        title: '系统提示',
        content: '您的帐号已到期，想要继续使用，请联系管理员!',
        isLink: !isLogin,
        link: BASE_URL + '/login' + (currentPath ? '?from=' + currentPath : ''),
      })
    } else if (res.data?.code !== 200) {
      res.config.isTips && message.error(res.data.msg, 3)
    }
    
    // token 自动续期
    // const token = res.headers[TOKEN_HEADER_NAME.toLowerCase()]
    // if (token) {
    //   setToken(token)
    // }
    return res.data
  },
  (error) => {
    if (error?.code === 'ERR_NETWORK') {
      // router.push({ path: '500' })
    }
    return Promise.reject(error)
  }
)

function showMessageBox ({ title, content, isLink, link }) {
	Modal.warning({
		content, 
		title, 
		okText: '确定',
		onOk() {
			removeToken()          
			isLink && window.location.replace(link)
		}
	})
}

function filterUrl (url) {
  return url.indexOf('?') !== -1 ? `${url}&current_time=${new Date().getTime()}` : `${url}?current_time=${new Date().getTime()}`
}

let http = {
  post(url, data, options) {
    return new Promise((resolve, reject) => {
      // service.post(url, params, options)
      service({
        method: 'post',
        url: filterUrl(url),
        data,
        ...options
      })
        .then(response => {
          resolve(response)
        }, err => {
          reject(err)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  get(url, params, options) {
    return new Promise((resolve, reject) => {
      service({
        method: 'get',
        url: filterUrl(url),
        params,
        ...options
      })
        .then(response => {
          resolve(response)
        }, err => {
          reject(err)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  put(url, data, options) {
    return new Promise((resolve, reject) => {
      service({
        method: 'put',
        url: filterUrl(url),
        data,
        ...options
      })
        .then(response => {
          resolve(response)
        }, err => {
          reject(err)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  delete(url, params, options) {
    return new Promise((resolve, reject) => {
      service({
        method: 'delete',
        url: filterUrl(url),
        params,
        ...options
      })
        .then(response => {
          resolve(response)
        }, err => {
          reject(err)
        })
        .catch((error) => {
          reject(error)
        })
    })
  }
}

export default http

